import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultarIntencaoVenda } from './types';

export const INITIAL_STATE: ConsultarIntencaoVenda = {
	status: 0,
	data: null,
	dados: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultarIntencaoVenda {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_INTENCAO_VENDA_REQUEST: {
				break;
			}

			case Types.CONSULTAR_INTENCAO_VENDA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_INTENCAO_VENDA_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_INTENCAO_VENDA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.dados = INITIAL_STATE.dados;
				break;
			}

			default:
		}
		return draft;
	});
}
